/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
const INITIAL_STATE = {
  step: 1,
  installBase: '',
  phone: '',
  currentGasPercentage: 0,
  refuelDate: '',
  isFixRoute: '',
  name: '',
  telefone: '',
  details: '',
  detail: '',
  protocol: '',
  textReturnAPI: '',
};

const novoAbastecimentoReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  if (type === 'TOGGLE_STEP') {
    return {
      ...state,
      step: action.step,
    };
  }
  if (type === 'TOGGLE_IS_SUBMITTING') {
    return {
      ...state,
      isSubmitting: action.isSubmitting,
    };
  }
  if (type === 'REGISTER_INSTALLBASE') {
    return {
      ...state,
      installBase: action.installBase,
      numberOfDaysToSuplay: action.numberOfDaysToSuplay,
    };
  }
  if (type === 'REGISTER_PHONE') {
    return {
      ...state,
      phone: action.phone,
    };
  }
  if (type === 'REGISTER_CURRENTGASPERCENTAGE') {
    return {
      ...state,
      currentGasPercentage: action.currentGasPercentage,
    };
  }
  if (type === 'REGISTER_REFUELDATE') {
    return {
      ...state,
      refuelDate: action.refuelDate,
      isFixRoute: action.isFixRoute,
    };
  }
  if (type === 'REGISTER_DADOSRESPONSAVEL') {
    return {
      ...state,
      name: action.name,
      phone: action.phone,
      email: action.email,
      detail: action.detail,
    };
  }
  if (type === 'REGISTER_PROTOCOL') {
    return {
      ...state,
      protocol: action.protocol,
      textReturnAPI: action.textReturnAPI,
    };
  }
  if (type === 'RESET_STEP') {
    return {
      step: 1,
    };
  }
  return {
    ...state,
  };
};

export default novoAbastecimentoReducer;
